<template>
    <div class="col-md-12">
            <a class="link-text" :href="link" target="_blank">
        <div class="mb-2">
            <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-9">
                    <h5 style="font-weight: 400; color: #6c757d">{{titulo}}</h5>
                </div>
                <div class="col-3">
                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div> 
            </div> 
        </div>
    </a> 
    </div>
</template>
<script>
export default {
  props: {
    link: {
      type: String,
      required: true
    },
    titulo: {
      type: String,
      required: true
    }

  }
};
</script>
<style scoped>
.link-text{
    text-decoration: none;
}
.title_document h5{
    font-size: 0.9rem!important;
}
.descargar{
   font-size: 0.9rem;
   color: #6c757d !important;
}
</style>